"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Ruler = function Ruler(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 16 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#fff" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 16",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.8661971,6.81634665 L17.378847,2.4993911 C17.1038636,2.02149934 16.4945253,1.85901615 16.0195539,2.13300742 L13.8634338,3.37871194 L15.7289464,6.61881805 C15.7976922,6.73988396 15.7570697,6.88962338 15.6383268,6.95971417 L15.2071028,7.20821789 C15.08836,7.27830868 14.9352442,7.23689139 14.8664983,7.11582548 L13.0009857,3.87890531 L11.2760896,4.87610611 L12.1479121,6.38624406 C12.216658,6.50730998 12.1760354,6.65704939 12.0572926,6.72714018 L11.6260685,6.9756439 C11.5073257,7.04573469 11.3542099,7.0043174 11.2854641,6.88325149 L10.4136416,5.37629948 L8.68874549,6.37350028 L10.5573829,9.6136064 C10.6261288,9.73148637 10.5855062,9.88441173 10.4667634,9.95450252 L10.0355394,10.2030062 C9.91679651,10.273097 9.76368073,10.2316797 9.69493487,10.1106138 L7.82942225,6.87050771 L6.10452616,7.86770851 L6.97634864,9.37784647 C7.0450945,9.49891238 7.00447195,9.6486518 6.8857291,9.71874259 L6.45450508,9.9672463 C6.33576223,10.0373371 6.18264645,9.99591981 6.1139006,9.87485389 L5.24207811,8.36153 L3.51718202,9.3587308 L5.38269464,12.5988369 C5.4514405,12.7167169 5.41081795,12.8696422 5.2920751,12.939733 L4.86085108,13.1882367 C4.74210823,13.2583275 4.58899246,13.2169103 4.5202466,13.0958443 L2.65473398,9.86529606 L0.498613864,11.1110006 C0.0236424763,11.3881778 -0.141972547,11.9966933 0.133010888,12.4745851 L2.62036105,16.7947265 C2.89534448,17.2726183 3.50468278,17.4351015 3.97965416,17.1611102 L19.503719,8.17993113 C19.9786904,7.90593985 20.1411806,7.2942384 19.8661971,6.81634665 Z",
    id: "ruler"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#ruler"
  }));
};

var _default = Ruler;
exports["default"] = _default;
module.exports = exports["default"];